// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ogripwmsopctiljhqivm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ncmlwd21zb3BjdGlsamhxaXZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU0MDkzMDMsImV4cCI6MjA3MDk4NTMwM30.HmFJoSSBLBbUv-oa2kP0bXkuy33ZFcSIm5KN7iTgb0U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});